import React, { useEffect, useState } from 'react'
import HeroSection from './HeroSection'
import ReachOut from './ReachOut'
import Testinomials from './Testinomials'
import { Helmet } from 'react-helmet-async'
import { getMetadataByPage } from "../../API/Api";

const Contact = () => {  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getMetadataByPage("contact");
      setMetadata(data);
    };
    fetchMetadata();
  }, []);
  return (
    <>
      {metadata && (
        <Helmet>
          <title>{metadata?.title || "Anaxistech"}</title>
          <meta
            name="description"
            content={metadata?.description || "Default description"}
          />
          <meta
            name="keywords"
            content={metadata?.keywords || "tech, services"}
          />
          <meta
            property="og:title"
            content={metadata?.ogTitle || metadata?.title || "Anaxistech"}
          />
          <meta
            property="og:description"
            content={
              metadata?.ogDescription ||
              metadata?.description ||
              "Default description"
            }
          />
          <meta
            property="og:image"
            content={metadata?.ogImage || "/default-image.png"}
          />
        </Helmet>
      )}
    <HeroSection/>
    <ReachOut/>
    <Testinomials/>
    </>
  )
}

export default Contact